export default {
    root: {},
    "spacing-xs-2": {
        "& > .MuiGrid-item": {
            padding: 4,
        },
    },
};
